import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import MenuGalleries from './MenuGalleries';
import { colors } from '../../styles';

const styles = css`
  .PhotoGallery {
    @media (min-width: 992px) {
      padding-bottom: 150px;
    }
  }
  .PhotoGallery_categoryTitle {
    font-weight: 800;
    font-size: 24px;
    color: #3F3F3F;
    letter-spacing: 4px;
    text-align: center;
    line-height: 36px;
    text-transform: uppercase;
    margin: 40px 0 80px 0;
    position: relative;
    @media (min-width: 992px) {
      font-size: 41px;
      margin: 0 0 80px 0;
    }
    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 150px;
      height: 3px;
      left: 50%;
      margin-left: -75px;
      background-color: ${colors.color3};
      bottom: -40px;
    }
  }
  .PhotoGallery_categoryPostTitle {
    font-weight: 300;
    color: ${colors.color1};
  }
`;

function PhotoGallery({ page, router }) {
  const route = RouteCollection.getRouteByPath(_.get('location.pathname', router));
  const gallerySlug = _.get('params.gallery', route);
  let activeGallery;
  let photos = [];

  if (gallerySlug) {
    activeGallery = _.getOr([], 'photo_gallery', page)
      .find(g => Slugify(_.getOr('', 'category_name', g)) === gallerySlug);
    photos = _.getOr([], 'category_photos', activeGallery);
  } else {
    photos = _.flow(
      _.map('category_photos'),
      _.flatten,
    )(_.getOr([], 'photo_gallery', page));
  }

  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        h1={_.get('meta.name', page)}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuGalleries
        page={page}
      />
      <div className="PhotoGallery container">
        <div className="row">
          <div className="col-12">
            {
              activeGallery &&
              <h3 className="text-center PhotoGallery_categoryTitle">
                {_.get('category_name', activeGallery)}
                {' '}
                <span className="PhotoGallery_categoryPostTitle">Photos</span>
              </h3>
            }
            <LightBoxPhotoList
              show={12}
              gallery={_.get('category_name', activeGallery)}
              photos={photos}
            />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

PhotoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  page: 'photo_gallery',
  router: true,
})(PhotoGallery);



// WEBPACK FOOTER //
// ./src/pages/PhotoGallery/index.js